
import moment from 'moment-timezone';

export class TimingFormat {    
    public static formatDateString = "MM/DD/YYYY";
    public static formatTimeString12Hour = true;

    public static formatTime(inTime) {
        if (inTime === null || inTime === undefined) return "0:00";
        let timeFormat = '0:00';

        if (inTime.split) {
            if (inTime.split(':').length == 3) {
                if (parseInt(inTime.split(':')[0]) > 0) {
                    timeFormat = parseInt(inTime.split(':')[0]) + ':' + inTime.split(':')[1] + ':' + inTime.split(':')[2];
                } else {
                    timeFormat = parseInt(inTime.split(':')[1]) + ':' + inTime.split(':')[2];
                }
            } else if (inTime.split(':').length == 2) {
                timeFormat = parseInt(inTime.split(':')[0]) + ':' + inTime.split(':')[1];
            } else {
                timeFormat = inTime;
            }
        }
        else {
            let sec_num = parseInt(inTime, 10);
            let hours = Math.floor(sec_num / 3600);
            let minutes: any = Math.floor((sec_num - (hours * 3600)) / 60);
            let seconds: any = sec_num - (hours * 3600) - (minutes * 60);

            if ((minutes < 10) && (hours > 0)) { minutes = "0" + minutes; }
            if (seconds < 10) { seconds = "0" + seconds; }
            if (hours > 0) {
                timeFormat = hours + ':' + minutes + ':' + seconds;
            } else {
                timeFormat = minutes + ':' + seconds;
            }
        }

        return timeFormat;
    }

    
    public static formatTimeHMMSSADST(intime) {
        if (TimingFormat.formatTimeString12Hour) {
            return TimingFormat._DSTAdjusted(intime).format('h:mm:ss A');
        } else {
            return TimingFormat._DSTAdjusted(intime).format('H:mm:ss');
        }
    }
    
    private static _DSTAdjusted(inDate) {
        if (String(inDate) != "0001-01-01T00:00:00") {
            if (String(inDate).indexOf('M') < 0) { //check if string is already been parsed once and contains AM or PM
                if (String(inDate).indexOf('Z') < 0) inDate = inDate + 'Z';
                var today = new Date();
                if (!moment(inDate).isDST() && moment(today).isDST()) {
                    return moment(inDate).hours(moment(inDate).hours() + 1);
                } else {
                    return moment(inDate);
                }
            } else {
                return moment(inDate);
            }
        } else {
            return moment(inDate);
        }
    }

    public static convertMOSDateTime(value) {
        if (value != "1800-01-01T00:00:00") {
            var convertedFormat = TimingFormat.formatDateTimeDST(value, true);
            if (convertedFormat == 'Invalid date') {
                convertedFormat = value;
            }
        } else {
            convertedFormat = "";
        }
        return convertedFormat;
    }    
    
    public static formatDateTimeDST(inDate, seconds) {
        if (seconds == true) {
            if (TimingFormat.formatTimeString12Hour) {
                return TimingFormat._DSTAdjusted(inDate).format(TimingFormat.formatDateString + ", hh:mm:ss A");
            } else {
                return TimingFormat._DSTAdjusted(inDate).format(TimingFormat.formatDateString + ", HH:mm:ss");
            }
        }
        else {
            if (TimingFormat.formatTimeString12Hour) {
                return TimingFormat._DSTAdjusted(inDate).format(TimingFormat.formatDateString + ", hh:mm A");
            } else {
                return TimingFormat._DSTAdjusted(inDate).format(TimingFormat.formatDateString + ", HH:mm");
            }
        }
    }

    public static formatTimeHMMSSA(intime) {
        if (TimingFormat.formatTimeString12Hour) {
            return moment(intime).format('h:mm:ss A');
        } else {
            return moment(intime).format('H:mm:ss');
        }
    }

    public static formatDateDST(inDate) {
        return TimingFormat._DSTAdjusted(inDate).format(TimingFormat.formatDateString);
    }
}
